/**
 * @generated SignedSource<<9c4ab522d3d83be679b68173aa410700>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteTestObjectMutation$variables = {
  id: string;
};
export type DeleteTestObjectMutation$data = {
  readonly deleteTestObject: {
    readonly id: string;
  };
};
export type DeleteTestObjectMutation = {
  response: DeleteTestObjectMutation$data;
  variables: DeleteTestObjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteTestObjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TestObject",
        "kind": "LinkedField",
        "name": "deleteTestObject",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteTestObjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TestObject",
        "kind": "LinkedField",
        "name": "deleteTestObject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1613eb745cb47b89f08f627de03d5f02",
    "id": null,
    "metadata": {},
    "name": "DeleteTestObjectMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteTestObjectMutation(\n  $id: ID!\n) {\n  deleteTestObject(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "338e1db4834ca22c5215378ba2dc6eb7";

export default node;
